
import React from 'react';
import Lightbox from "react-image-lightbox";
import CustomImage from '/components/customImage';

class ImgLightbox extends React.Component{
    constructor(props){
        super(props);
        this.state = {
          isOpen: false,
          photoIndex: 0,
        };
      }
    render(){
        const { imgProps, imgArr } = this.props;
        const { isOpen, photoIndex } = this.state;
        const originalImgSrc = imgProps.props.src;
        let lightboxImgSrc = originalImgSrc.search("/conversions/") > -1 && originalImgSrc.search("-content.") > -1 ? originalImgSrc.replace("-content.", "-lightbox." ) : originalImgSrc 
        let photos = imgArr.length > 0 && imgArr.map(image => image.search("/conversions/") > -1 && image.search("-content.") > -1 ? image.replace("-content.", "-lightbox." ) : image )
        let clickImgIndex = photos.findIndex(photo => photo === lightboxImgSrc);
        return (
           <React.Fragment>
                <div className="imgClick" style={{ cursor: 'pointer', marginTop: '8px' }} onClick={() => this.setState({ isOpen: true, photoIndex: clickImgIndex })}>
                    <CustomImage 
                        imgSrc={originalImgSrc} 
                        imgClass="img-fluid"
                    />               
                </div>
                {isOpen && (
                    photos.length > 1 ?
                     <Lightbox
                        mainSrc={photos[photoIndex]}
                        nextSrc={photos[(photoIndex + 1) % photos.length]}
                        prevSrc={photos[(photoIndex + photos.length - 1) % photos.length]}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + photos.length - 1) % photos.length
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % photos.length
                        })
                        }
                    />
                    :
                    <Lightbox
                        mainSrc={lightboxImgSrc}
                        onCloseRequest={() => this.setState({ isOpen: false })} 
                    />
                    
                )}
            </React.Fragment>
        );
        
    }
   
}


export default ImgLightbox;



